import { render, staticRenderFns } from "./FoodPortionEditDialog.vue?vue&type=template&id=4ca8beed"
import script from "./FoodPortionEditDialog.vue?vue&type=script&lang=js"
export * from "./FoodPortionEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports